// extracted by mini-css-extract-plugin
module.exports = {"shadowBoxOverlay":"src-lib-app-components-elements-containers-ShadowBoxOverlay-index-module__shadowBoxOverlay--YX1L6"};